import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import "flag-icon-css/css/flag-icon.min.css";
import { default as React, useContext, useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useAuthContextUser } from "context/AuthContext";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import { userService } from "services/user.service";
import ErrorPage from "pages/Error/ErrorPage";
import OrganizationInformation from "./Components/OrganizationInformation";
import PaymentInformation from "./Components/PaymentInformation";
import UserInfo from "./Components/UserInfo";

const AccountInfo = () => {
  const [error, setError] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const user = useAuthContextUser();
  const [organizationData, setOrganizationData] = useState(null);
  const [userData, setUserData] = useState({});
  const alertContext = useContext(GlobalAlertContext);

  const fetchData = () => {
    trackPromise(
      userService.GetUserInfo()
        .then((response) => {
          let result = response.data.result
          result.jobTitle = result.jobTitle === null ? "" : result.jobTitle;
          result.phone = result.phone === null ? "" : result.phone;
          setUserData(result);
          setOrganizationData(result.organization);
        })
        .catch((error) => {
          setError(error);
          alertContext.setGlobalErrorMessage(error.message);
        })
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (error) {
    return <ErrorPage text={error.message} />;
  } else {
    return (
      <>
        <GlobalAlertContext.Consumer>
          {(alertObj) => (
            <>
              {promiseInProgress && <MCSOverlayLoading />}
              <Grid>
                <Row>
                  <Col>
                    <Typography tag="h1">Account Information</Typography>
                  </Col>
                </Row>
                {organizationData && userData &&
                  <>
                    <div style={{ marginBottom: "20px" }}>
                      <OrganizationInformation
                        organizationData={organizationData}
                        isCompanyAdmin={user && user.isCompanyAdmin}
                        setOrganizationData={setOrganizationData}
                      />
                      {user && user.isCompanyAdmin && organizationData && (
                        <>
                          <PaymentInformation
                            organizationData={organizationData}
                            setOrganizationData={setOrganizationData}
                          />
                        </>
                      )}
                      <UserInfo userData={userData} />
                    </div>
                  </>
                }
              </Grid>
            </>
          )}
        </GlobalAlertContext.Consumer>
      </>
    );
  }
};
export default AccountInfo;
